import React, { useState, useEffect } from "react";
import './home.scss';
import appInfo from '../../app-info';
import { DevButton } from "../../components/devx";
import { useDispatch, useSelector } from "react-redux";
import CustomStore from "devextreme/data/custom_store";
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import KanunsuzBildirimDetayForm from '../home/KanunsuzBildirimDetayForm';
import { Popup } from 'devextreme-react/popup';
import { parseDate, hasRole } from "../../utils/Utils";
import Box, {
  Item
} from 'devextreme-react/box';
import TextBox from "devextreme-react/text-box";
import HomeAnnotationTemplate from './HomeAnnotationTemplate.js'; 

import { TreeList, FilterRow as TreeFilterRow, Selection as TreeSelection, Column as TreeColumn } from 'devextreme-react/tree-list';
import DataGrid, {
  Column,
  FilterRow,
  ColumnChooser,
  Paging,
  Pager, Selection, Scrolling
} from 'devextreme-react/data-grid';



import { Chart, Series, CommonSeriesSettings,   Format,Tooltip, Legend,  ArgumentAxis,
  Grid,
  Label,Export,Annotation,CommonAnnotationSettings, SeriesTemplate, Title, Subtitle, Size, AdaptiveLayout } from 'devextreme-react/chart';

const Home = () => {

  const dispatch = useDispatch();
  const [formYetki, setFormYetki] = useState(
    {
      domainKayitList: hasRole("home|homeform|domainKayitList"),
      kanunsuzBildirimList: hasRole("home|homeform|kanunsuzBildirimList"),
      kanunsuzBildirimDetayList: hasRole("home|homeform|kanunsuzBildirimDetayList"),
      calisanSayiListesi: hasRole("home|homeform|calisanSayiListesi"),
      tesvikSayilari: hasRole("home|homeform|tesvikSayilari"),
      borcEmanetBilgisi: hasRole("home|homeform|borcEmanetBilgisi"),
    });

  const [domainStore, setDomainStore] = useState(null);
  const [domainData, setDomainData] = useState(null);
  const [kanunsuzBildirimStore, setKanunsuzBildirimStore] = useState(null);
  const [kanunsuzBildirimDetayData, setKanunsuzBildirimDetayData] = useState({ popupState: false, data: [] });

  const [calisanSayiDataSource, setCalisanSayiDataSource] = useState(null);
  const [tesvikSayiDataSource, setTesvikSayiDataSource] = useState(null);
 
  const [borcEmanetStore, setBorcEmanetStore] = useState({});

  useEffect(() => {
    setDomainStore(getDomainStore());
    getKanunsuzBildirimList();
  }, []);

  useEffect(() => {
    setCalisanSayi();
    setTesvikSayi();
    setBorcEmanetBilgi();
  }, [domainData]);

  const getDomainStore = () => {
    return new CustomStore({
      key: 'id',
      load: function () {

        if (formYetki.domainKayitList) {
          const request = new Request("/home/getDomainKayitList", "GET");

          return request.run()
            .then(response => {
              if (response.data) {
                return {
                  data: response.data.data,
                  totalCount: response.data.total,
                  summary: 0,
                  groupCount: 0
                };
              } else {
                return [];
              }
            });
        } else {
          return [];
        }

      }
    });
  }
  const getKanunsuzBildirimList = () => {

   if (formYetki.calisanSayiListesi) {
      const request = new Request("/home/getKanunsuzBildirimList", "GET");

      return request.run()
        .then(response => {
          if (response.data) {
            setKanunsuzBildirimStore(response.data.data);
          } else {
            setKanunsuzBildirimStore([]);
          }
        });
    } else {
      setKanunsuzBildirimStore([]);
    }



    // return new CustomStore({
    //   key: 'id',
    //   load: function () {

    //     if (formYetki.kanunsuzBildirimList) {
    //       const request = new Request("/home/getKanunsuzBildirimList", "GET");

    //       return request.run()
    //         .then(response => {
    //           if (response.data) {
    //             return {
    //               data: response.data.data,
    //               totalCount: response.data.data.length,
    //               summary: 0,
    //               groupCount: 0
    //             };
    //           } else {
    //             return []

    //           }
    //         });
    //     } else {
    //       return []
    //     }

    //   }
    // });
  }
  const setCalisanSayi = () => {
    if (domainData == null) {
      setCalisanSayiDataSource([]);
      return;
    }
    if (formYetki.calisanSayiListesi) {
      const request = new Request("/home/getCalisanSayiInfoList/" + domainData.id, "GET");

      return request.run()
        .then(response => {
          if (response.data) {
            setCalisanSayiDataSource(response.data.data);
          } else {
            setCalisanSayiDataSource([]);
          }
        });
    } else {
      setCalisanSayiDataSource([]);
    }

  }
  const setTesvikSayi = () => {
    if (domainData == null) {
      setTesvikSayiDataSource([]);
      return;
    }
    if (formYetki.tesvikSayilari) {
      const request = new Request("/home/getTesvikSayilari/" + domainData.id, "GET");

      return request.run()
        .then(response => {
          if (response.data) {
            setTesvikSayiDataSource(response.data.data);
          } else {
            setTesvikSayiDataSource([]);
          }
        });
    } else {
      setTesvikSayiDataSource([]);
    }
  }
  const setBorcEmanetBilgi = () => {
   
    if (domainData == null) {
      setBorcEmanetStore({});
      return;
    }
    setBorcEmanetStore({loading:true});
    if (formYetki.borcEmanetBilgisi) {
      const request = new Request("/home/getBorcEmanet/" + domainData.id, "GET");

      return request.run()
        .then(response => {
          
          if (response.data && response.data.data) {
            setBorcEmanetStore(response.data.data);
          } else {
            setBorcEmanetStore({});
          }
          if(response && response.response && response.response.data && response.response.data.message){
            if(response.response.data.message.includes("ErrorCode:user001")){
              setBorcEmanetStore({sifreHatasi:true});
            }else{
              setBorcEmanetStore({hataMesaji:response.response.data.message});
            }
          }
        });
    } else {
      setBorcEmanetStore({});
    }
  }
  function onTreeSelectionChanged(selections) {
    if (selections.selectedRowKeys.length > 0) {
      let data = selections.selectedRowsData[0];
      if (data.sicilNo != null) {
        setDomainData(data);
      }
    }
  }


  function hizliGirisLogin(sistem) {
    if (domainData != null) {

      const request = new Request("/home/getKayitByHizliGiris/" + domainData.id + "/" + sistem, "GET");
      request.run()
        .then(response => {
          let url = response.data.data
          window.open(url, "_blank");
        });


    }
  }
  function kanunsuzBildirimDetay(data) {

    if (data != null && data.domainId != null) {
      setKanunsuzBildirimDetayData({
        popupState: true,
        data: { domainId: data.domainId }
      });

    }
  }
  function hideKanunsuzBildirimDetayDataPopup() {
    setKanunsuzBildirimDetayData({ popupState: false, data: {} })
  }
  function customizeTooltip(arg) {
    return {
      text: `${arg.seriesName } years: ${ arg.valueText}`
    };
  }
  function onPointClick(e) {
    kanunsuzBildirimDetay(e.target.data) 
  }
  function onAnnotationClick(data) {
    kanunsuzBildirimDetay(data) 
  }
  return <React.Fragment>
    <Box direction="row" width="100%" height="100%">
      <Item ratio={1}>
        <TreeList
          id="menus"
          className="homeDomainTree"
          rootValue={null}
          dataSource={domainStore}
          showBorders={true}
          columnHidingEnabled={true}
          columnAutoWidth={true}
          showRowLines={true}
          defaultExpandedRowKeys={[1]}
          keyExpr={"id"}
          parentIdExpr={"parent.id"}
          onSelectionChanged={onTreeSelectionChanged}
        //onToolbarPreparing={onToolbarPreparingDetay}
        >
          <TreeSelection mode="single" />
          <TreeFilterRow visible={true} />

          <TreeColumn dataField="name" caption="Adı" defaultSortOrder="asc" />

        </TreeList>
      </Item>

      <Item ratio={4}>
        <Box direction="col" width="100%" height="100%">
          {/* <Item ratio={0} baseSize={50}>
            <h2 >{domainData != null ? "Firma: " + domainData.name : ""}</h2>
          </Item> */}

          <Item ratio={2} baseSize={0}>
            <Box direction="row" width="100%" height="100%">
              <Item ratio={2} baseSize={0}>
                <Chart
                  id="kanunsuzBildirimChart"
                  dataSource={kanunsuzBildirimStore}
                  //palette="Violet"
                  title={"Kanunsuz Bildirim Listesi"}
                  // onClick={onAnnotationClick}
                  // onLegendClick={onAnnotationClick}
                   onPointClick={onPointClick}
                  // onArgumentAxisClick={onAnnotationClick} 
                >
                   
                  <CommonSeriesSettings
                    argumentField="count"
                    type="bar"
                    hoverMode="allArgumentPoints"
                    selectionMode="allArgumentPoints"
                  >
                    <Label visible={true}>
                      <Format type="fixedPoint" precision={0} />
                      {/* <Format type="fixedPoint" precision={0}  rotationAngle={20} overlappingBehavior="rotate" /> */}
                    </Label>
                  </CommonSeriesSettings>
                  <Series
                    valueField="count"
                    argumentField="sicilNo"
                    name="Population"
                    type="bar" />

                  <CommonAnnotationSettings
                    type="custom"
                    series="Population"
                    render={HomeAnnotationTemplate}
                    allowDragging={true} 
                  ></CommonAnnotationSettings>
                    {kanunsuzBildirimStore && kanunsuzBildirimStore.map(data => {
                      return (
                        <Annotation  
                          argument={data.sicilNo}
                          key={data.sicilNo}
                          data={data} 
                          onClick={onAnnotationClick}
                        /> 
                      );
                    })}
                  <Legend visible={false}></Legend>
                  {/* <Tooltip
                    enabled={true}
                    location="center"
                    customizeTooltip={customizeTooltip}
                  /> */}
                  <Export enabled={true} />
                </Chart>
                 
              </Item>
              <Item ratio={2} baseSize={0}>
                <div  >
                  <Chart id="chart"
                    title={domainData != null ? "Çalışan Sayı(" + domainData.name + ")" : "Çalışan Sayı"}
                    dataSource={calisanSayiDataSource}
                  // onPointClick={this.onPointClick}
                  >
                    <CommonSeriesSettings argumentField="donem" type="bar" hoverMode="allArgumentPoints" selectionMode="allArgumentPoints" >
                      <Label visible={true}>
                        <Format type="fixedPoint" precision={0} />
                      </Label>
                    </CommonSeriesSettings>
                    <Series valueField="calisanSayi6111" name="6111" />
                    <Series valueField="calisanSayi7103" name="7103" />
                    {/* <Legend verticalAlignment="bottom" horizontalAlignment="center"></Legend> */}
                    <Export enabled={true} />
                  </Chart>
                </div>
              </Item>
            </Box>
          </Item>
          <Item ratio={2} baseSize={0}>
            <Chart id="chartTesvikSayilari"
              dataSource={tesvikSayiDataSource}
              palette="Violet"
              title={domainData != null ? "Teşvik Sayıları(" + domainData.name + ")" : "Teşvik Sayıları"}
            // onPointClick={this.onPointClick}
            >
              <SeriesTemplate
                nameField="donem"
              //customizeSeries={customizeSeries}
              />
              <CommonSeriesSettings argumentField="kanun" valueField="count" type="bar">
                <Label visible={true}>
                  <Format type="fixedPoint" precision={0} />
                </Label>
              </CommonSeriesSettings>
              <Legend
                verticalAlignment="bottom"
                horizontalAlignment="center"
              />
              <Export enabled={true} />
            </Chart>
          </Item>
          <Item ratio={0} baseSize={40}>
            <Box direction="row" width="100%" height="100%">
              <Item ratio={0} baseSize={90}>
                <div> Borç Toplamı:</div>
              </Item>
              <Item ratio={0} baseSize={70}> 
                  <TextBox readOnly={true} hoverStateEnabled={false} value={borcEmanetStore.borcToplami} /> 
              </Item>
              <Item ratio={0} baseSize={150}>
                <div> Gecikme Zammı Toplamı:</div>
              </Item>
              <Item ratio={0} baseSize={70}> 
                  <TextBox readOnly={true} hoverStateEnabled={false} value={borcEmanetStore.gecilmeZammiToplami} /> 
              </Item>
              <Item ratio={0} baseSize={90}>
                <div> Banka Toplam:</div>
              </Item>
              <Item ratio={0} baseSize={70}> 
                  <TextBox readOnly={true} hoverStateEnabled={false} value={borcEmanetStore.bankaToplami} /> 
              </Item>
              <Item ratio={0} baseSize={90}>
                <div> Mosip Toplam:</div>
              </Item>
              <Item ratio={0} baseSize={70}> 
                  <TextBox readOnly={true} hoverStateEnabled={false} value={borcEmanetStore.mosipToplami} /> 
              </Item>
              <Item ratio={1} > 
                  {
                    borcEmanetStore.loading ?  <text style={{fontWeight: "bold", color: 'black'}}> Kayıt yükleniyor</text>  :
                    borcEmanetStore.sifreHatasi ?  <text style={{fontWeight: "bold" , color: 'red'}}> Şifre hatalı...</text>  : 
                    borcEmanetStore.hataMesaji ?  <text style={{fontWeight: "bold" ,color: 'red'}}> Hata Oluştu {borcEmanetStore.hataMesaji}</text> : ""                    
                  }  
              </Item>
            </Box>
          </Item>

          <Item ratio={0} baseSize={40}>
            <Box direction="row" width="100%" height="100%">
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="İşveren Sistemi"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("isveren"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="Bildirge V2"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("bildirge"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="İşbaşı"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("isbasi"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="Engelli Teşvik"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("engelli"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="Bildirge V1"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("bildirgeV1"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="İş Kazası"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("isKazasi"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="Sigorta Tescil-4A"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("sigortatescil4A"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
              <Item ratio={1} baseSize={0}>
                <Button
                  icon="upload"
                  width={150}
                  text="Rapor Onay"
                  type={'success'}
                  style={{ fontSize: "15px" }}
                  onClick={(e) => { hizliGirisLogin("raporOnay"); }}
                // visible={formYetki.cariDonemExcelXmlImport}
                />
              </Item>
            </Box>

          </Item>
        </Box>
      </Item>
    </Box>

    <Popup
      visible={kanunsuzBildirimDetayData.popupState}
      onHiding={hideKanunsuzBildirimDetayDataPopup}
      dragEnabled={false}
      closeOnOutsideClick={false}
      //showTitle={true}
      title="   Teşvik Rapor Fark Detay"
      width={1000}
      height={600}
    >
      <div>
        {kanunsuzBildirimDetayData.popupState ? <KanunsuzBildirimDetayForm data={kanunsuzBildirimDetayData.data} hide={hideKanunsuzBildirimDetayDataPopup} /> : null}
        <Button
          width={1000}
          text="Kapat"
          type="danger"
          stylingMode="contained"
          onClick={hideKanunsuzBildirimDetayDataPopup}
        />
      </div>
    </Popup>

  </React.Fragment>
}

export default Home;
